import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[charsOnlyValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: CharsOnlyDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class CharsOnlyDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^[a-zA-ZÀ-ÿčęàâæéêèëïîôœûùç ]*$/.test(control.value)
     ? null
     : { invalid : true };
 }
}